'use client';

import { usePathname } from 'next/navigation';

import { getUrl } from '~/utils/get-url';
import { StorageKey } from '~/utils/storage-key';

import { CopyAction } from './copy';
import LinkIcon from '../icons/link.svg';

export function CopyLinkAction({ isDraft }: { isDraft: boolean }) {
  const pathname = usePathname();

  if (!pathname) {
    return null;
  }

  const url = getUrl('/login');
  url.searchParams.set(StorageKey.NEXT, pathname);
  url.searchParams.set(StorageKey.DRAFT, isDraft.toString());
  const link = url.toString();

  return (
    <CopyAction tooltip={isDraft ? 'Copy link to draft' : 'Copy link'} copyContent={link}>
      <LinkIcon />
    </CopyAction>
  );
}
